import { gql } from '@provision/graphql-client';
import { PLATFORM_FIELDS } from 'src/graphql';

export const BLOCKED_PHONE_NUMBER_FRAGMENT = gql`
  fragment BlockedPhoneNumberFields on BlockedPhoneNumber {
    id
    blockedPhoneNumberId
    blockedPhoneNumber
    partnerId
    createdAt
    createdByPlatformUserId
  }
`;

export const BLOCKED_PHONE_NUMBER_RELATIONS = gql`
  fragment BlockedPhoneNumberRelations on BlockedPhoneNumber {
    id
    createdByPlatformUser {
      ...PlatformUserFields
    }
  }
  ${PLATFORM_FIELDS}
`;
